import { useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { AppBar, Box, Hidden, IconButton, Toolbar, Menu, MenuItem, Typography, Tooltip, ListItemIcon, ListItemText } from '@material-ui/core';
import Check from '@material-ui/icons/Check';
import MenuIcon from '@material-ui/icons/Menu';
import { logout } from '../hooks/useAuth';
import { makeStyles } from '@material-ui/core/styles';
import AccountIcon from '@material-ui/icons/AccountCircle'
import TranslateIcon from '@material-ui/icons/Translate';
import { getBasicDataClient } from '../services/Client';
import SpinnerLoad from './FormsUI/Spinner';
import Logo from './Logo';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../utils';

const useStyles = makeStyles((theme) => ({

}));

const languages = [
  { code: 'es', label: 'Español', flag: '🇪🇸' },
  { code: 'en', label: 'English', flag: '🇺🇸' },
  { code: 'pt', label: 'Português', flag: '🇧🇷' },
]

const DashboardNavbar = ({ onMobileNavOpen, ...rest }) => {
  const classes = useStyles();
  const [notifications] = useState([]);
  const [client, setClient] = useState(null);
  const navigate = useNavigate();
  const {t} = useTranslation();

  const handleLogout = () => {
    logout();
    navigate('/')
  }

  //menu item
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  /*** section language icon */
  const [anchorElLang, setAnchorElLang] = useState(null)
    const [selectedLang, setSelectedLang] = useState(localStorage.getItem('i18nextLng') || 'es')
    const openLang = Boolean(anchorElLang)
  
    const handleOpenLangMenu = (event) => {
      setAnchorElLang(event.currentTarget)
    }
  
    const handleCloseLangMenu = () => {
      setAnchorElLang(null)
    }
  
    const handleSelectLanguage = (code) => {
  
      changeLanguage(code); /**function change language i18n */
      setSelectedLang(code)
      handleCloseLangMenu()
    }
  /*** section language icon */

  useEffect(() => {

    const captureDataClient = async () => {
      const client = await getBasicDataClient();
      //console.log('client', client)

      if (client.error === true) {
        if (client.message.status === 401) {
          const fullpath = window.location.href;
          const iniposition = fullpath.indexOf("/cart");
          const path = fullpath.substring(iniposition);
          const pathini = path.substring(1, 5);
          //console.log("path", path);
          let pathnavigate = '/';
          if (pathini === 'cart') {
            pathnavigate = path;
          }
          logout();
          //navigate('/', {replace: true});
          navigate(pathnavigate, { replace: true });
        }
      }
      if (client.error === false) {
        setClient(client);
      }
    }

    captureDataClient();

  }, []);

  return (
    <AppBar className={classes.contMainNav}
      sx={{ backgroundColor: '#f8f9fb', top: '60px' }}
      elevation={0}
      {...rest}
    >
      {client === null ?
        <SpinnerLoad />
        :
        <>
          {client.error === false &&
            <Toolbar>
              <RouterLink to="/" >
                <Box sx={{ paddingLeft: 1 }} >
                  <Logo />
                </Box>
              </RouterLink>
              <Box sx={{ flexGrow: 1 }} />
              <Hidden lgDown>
                
                <Typography sx={{ color: '#596275', fontSize: '12px' }}><b>{t('hello')} {client.firstname} !</b></Typography>

                <Tooltip title={client.email}>
                  <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenu}
                    color="primary"
                    sx={{ padding: '6px' }}
                  >
                    <AccountIcon style={{ fontSize: '1.5em' }} />
                  </IconButton>
                </Tooltip>

                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={handleClose}

                > 
                  <MenuItem onClick={handleLogout}><Typography variant='h6'>{t('logout')}</Typography></MenuItem>
                  
                </Menu>

                <div>
                  <Tooltip title="Select language">
                    <IconButton
                        onClick={handleOpenLangMenu}
                        aria-label="Select language"
                        aria-controls={openLang ? 'language-menu' : undefined}
                        aria-haspopup="true"
                        aria-expanded={openLang ? 'true' : undefined}
                        sx={{backgroundColor: '#5F81FF', color: '#fff', padding: '3px', '&:hover': { backgroundColor: '#5F81FF', color: '#fff' } }}
                      >
                      <TranslateIcon />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    anchorEl={anchorElLang}
                    id="language-menu"
                    open={openLang}
                    onClose={handleCloseLangMenu}
                    onClick={handleCloseLangMenu}
                    transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                    anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
                  >
                    {languages.map((lang) => (
                      <MenuItem
                        key={lang.code}
                        selected={selectedLang === lang.code}
                        onClick={() => handleSelectLanguage(lang.code)}
                      >
                        <ListItemIcon sx={{ minWidth: 36 }}>
                          <Typography variant="body1">{lang.flag}</Typography>
                        </ListItemIcon>
                        <ListItemText>{lang.label}</ListItemText>
                        {selectedLang === lang.code && (
                          <ListItemIcon sx={{ minWidth: 'auto', ml: 2 }}>
                            <Check />
                          </ListItemIcon>
                        )}
                      </MenuItem>
                    ))}
                  </Menu>
                </div>


              </Hidden>

              <Hidden lgUp>
                <IconButton
                  color="primary"
                  onClick={onMobileNavOpen}
                >
                  <MenuIcon />
                </IconButton>
              </Hidden>
            </Toolbar>
          }
        </>

      }

    </AppBar>
  );
};

DashboardNavbar.propTypes = {
  onMobileNavOpen: PropTypes.func
};

export default DashboardNavbar;
